/* eslint-disable @next/next/no-img-element */
import { useState, useEffect } from "react";

// @material-tailwind/react components
import { Typography, Chip } from "@material-tailwind/react";

// page components
import CodePreview from "components/cards/code-preview";
import ReactLogo from "components/icons/react";
import HtmlLogo from "components/icons/html";
import AngularLogo from "components/icons/angular";
import VueLogo from "components/icons/vue";

export default function SectionFramework() {
  const [framework, setFramework] = useState("react");
  const [frameworkCode, setFrameworkCode] = useState(null);

  useEffect(() => {
    switch (framework) {
      case "react":
        setFrameworkCode(`
<Button className="flex items-center">
  <i className="mr-1 text-base leading-none material-icons">
    favorite
  </i>
  Button
</Button>
        `);
        break;
      case "html":
        setFrameworkCode(`<button
  class="button button-info"
  data-ripple-light="true"
>
  <i className="mr-1 text-base leading-none material-icons">
    favorite
  </i>
  Button
</button>`);
    }
  }, [framework]);

  return (
    <section className="py-24 lg:-mt-20">
      <div className="mt-5 flex flex-wrap items-center md:mt-10">
        <div className="relative w-full px-4 md:w-5/12">
          <Typography
            variant="h2"
            className="mb-2 font-black tracking-normal text-[#1A237E]"
          >
            With your favorite <br />
            <Typography
              as="span"
              variant="h2"
              color="blue"
              className="inline-block font-black tracking-normal"
              textGradient
            >
              Framework.
            </Typography>
          </Typography>
          <Typography className="mb-12 text-xl text-[#1A237E]/60 lg:pr-24">
            Realize your dream job with us. Our platform offers top-notch
            content designed to propel you towards success. We provide you with
            the finest resources to excel in your journey towards your dream
            career.
          </Typography>
        </div>
        <div className="relative w-full px-4 pt-24 md:w-6/12 md:pt-0">
          <CodePreview code={frameworkCode} />
          <img
            className="absolute top-48 w-full md:top-24 md:-right-20 lg:top-10 lg:-right-40"
            src="/img/blue.png"
            alt="tailwind_blob_blue"
          />
        </div>
      </div>
    </section>
  );
}
